module.exports = __webpack_public_path__ + "img/cropped-kitkit-phase3_icon-180x180.b97aeb0a.png";